import React from 'react';
import Select, { components } from 'react-select';

import { isEmpty, cloneDeep } from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';

import styles from './ACSelect.module.scss';

const customStyles = {
  option: (provided, state) => {
    const { data } = state;
    const { object = {} } = data;
    const { highlightColor } = object;
    if (isEmpty(object) || isEmpty(highlightColor)) return { ...provided };

    if (!isEmpty(highlightColor))
      return {
        ...provided,
        borderLeft: `3px solid ${highlightColor}`,
      };
  },
};

export default class ACSelect extends React.Component {
  onChangeOption = (selectedOption) => {
    const { name, onChangeFunc } = this.props;

    if (!onChangeFunc) return;
    onChangeFunc(name, selectedOption);
  };

  onInputChangeOption = (query) => {
    const { onInputChangeOptionFunc } = this.props;

    if (!query || !onInputChangeOptionFunc) return;
    onInputChangeOptionFunc(query);
  };

  getCompatibleOptions() {
    let compatibleOptions = [];
    const { options = [], optionLabel = '', optionValue = '', maxOptions = 100 } = this.props;

    if (!isEmpty(options)) {
      compatibleOptions = options.slice(0, maxOptions).map((o) => {
        return {
          label: o[optionLabel] || (o && o.id) || '' + o,
          value: o[optionValue] || (o && o.id) || '' + o,
          object: cloneDeep(o),
        };
      });
    }
    return compatibleOptions;
  }

  getCompatibleOption() {
    let selectedOption = {};
    const { option, optionLabel = '', optionValue = '' } = this.props;

    if (!isEmpty(option)) {
      selectedOption = {
        label: option[optionLabel] || option,
        value: option[optionValue] || option,
      };
    }

    return selectedOption;
  }

  renderSelect() {
    const { label = '', isDisabled = false } = this.props;
    const compatibleOptions = this.getCompatibleOptions();
    const compatibleOption = this.getCompatibleOption();
    return (
      <div className={styles.selectAutoComplete}>
        <div className={styles.selectAutoCompleteMain}>
          {!isEmpty(label) ? <span>{label}</span> : ''}
          <Select
            className={styles.select}
            styles={customStyles}
            inputId={`react-select-single-${compatibleOption.value}`}
            TextFieldProps={{
              label: { label },
              InputLabelProps: {
                htmlFor: 'react-select-single',
                shrink: true,
              },
              placeholder: 'Select',
            }}
            options={compatibleOptions}
            value={compatibleOption}
            onChange={this.onChangeOption}
            onInputChange={this.onInputChangeOption}
            isDisabled={isDisabled}
          />
        </div>
      </div>
    );
  }

  renderOptionWithToolTip(props) {
    if (isEmpty(props.data)) return null;

    let Option = (
      <Tooltip title={props.data.toolTip || ''}>
        <div>
          <components.Option {...props} />
        </div>
      </Tooltip>
    );
    return Option;
  }

  /**
   * Send options in following format
   * {
   * label:'ABC',
   * value:123,
   * toolTip:'Any tool tip string'
   * }
   */
  renderSelectWithToolTip() {
    const { label = '', options = [] } = this.props;
    const compatibleOptions = options;
    const compatibleOption = this.getCompatibleOption();

    return (
      <div className={styles.selectAutoComplete}>
        <div className={styles.selectAutoCompleteMain}>
          {!isEmpty(label) ? <span>{label}</span> : ''}
          <Select
            className={styles.select}
            inputId="react-select-single"
            TextFieldProps={{
              label: { label },
              InputLabelProps: {
                htmlFor: 'react-select-single',
                shrink: true,
              },
              placeholder: 'Select',
            }}
            options={compatibleOptions}
            // For more study: https://react-select.com/components#replaceable-components
            components={{ Option: this.renderOptionWithToolTip }}
            value={compatibleOption}
            onChange={this.onChangeOption}
            onInputChange={this.onInputChangeOption}
          />
        </div>
      </div>
    );
  }

  render() {
    const { isSelectWithToolTip = false } = this.props;
    return isSelectWithToolTip === true ? this.renderSelectWithToolTip() : this.renderSelect();
  }
}
